export const STRATEGIES_INTEGRATION_ASSISTED_TRANSFER = {
    "UseMainCall": (that) => {
        that.mainCall(0);
    },
    "UseSecondCall": (that) => {
        that.mainCall(1);
    },
    "TransferAssistedCall": (that) => {
        that.assistedTransferCall();
    },
    "DropSecondCall": (that) => {
        that.hangUpSecondCall();
    },
    "DropFirstCall": (that) => {
        that.hangUpConference();
    },
    "MakeConference": (that) => {
        that.startconference();
    },
    "LeaveConference": (that) => {
        that.leaveConference();
    },
    "assistedDialNumber": (that, message) => {
        that.dialNumber(message.phone);
    }
};



// WEBPACK FOOTER //
// ./src/js/Strategies/StrategiesIntegrationAssistedTransfer.js